// extracted by mini-css-extract-plugin
export var buttonContainer = "_8s-1";
export var fontSizeSelect = "_8s-3";
export var formatSelect = "_8s-2";
export var formats = "_8s-4";
export var hidden = "_8s-5";
export var icon = "_8s-6";
export var select = "_8s-0";